





































import 'vue-awesome/icons/angle-down'

export default
  name: 'popover_header'
  props: ['transaction']
  data: ->
    display_dropdown: false
  computed:
    allow_change: ->
      # Available only for new transactions and not transfers
      return true if @transaction.isNew()
      return !@transaction.isTransfer()
    date:
      get: -> hm_date.parse(@transaction.date)
      set: (val) -> @transaction.date = hm_date.format(val)
    button_classes: ->
      classes = 'text-' + @transaction.fullSubtype()
      classes += ' is-static' if !@allow_change
      classes
    transaction_subtype:
      get: -> @transaction.fullSubtype()
      set: (value) ->
        @display_dropdown = false
        if @transaction.isTransfer() || value.includes('transfer')
          attrs = { subtype: 't', transfer_type: 'a' } if value == 'transfer_accounts'
          attrs = { subtype: 't', transfer_type: 'v' } if value == 'transfer_virtuals'
          attrs = { subtype: 'i' } if value == 'income'
          attrs = { subtype: 'e' } if value == 'expense'
          attrs.date = @transaction.date
          @$store.dispatch 'hideTransactionsPopovers'
          @$nextTick =>
            @$store.dispatch('initTransaction', attrs).then (new_transaction) =>
              @$store.dispatch 'selectTransaction', new_transaction
        else
          @transaction.subtype = 'i' if value == 'income'
          @transaction.subtype = 'e' if value == 'expense'
  methods:
    hide: -> @$store.dispatch('hideTransactionsPopovers')
